import React from "react";
import "./App.css";
import { AuthProvider } from './context/AuthContext';
import { ToastProvider } from './context/ToastContext';
import AppRoutes from "./routes/AppRoutes";

const App = () => {
  return (
    <AuthProvider>
      <ToastProvider>
        <main>
          <AppRoutes />
        </main>
      </ToastProvider>
    </AuthProvider>
  );
};

export default App;
